module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Piotr_Patrycja.775955be.jpg";